import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import _ from 'lodash';

import { AnalyticsContextProvider } from '@nerdwallet/structured-content/contexts/AnalyticsContext';
import {
  useSegmentAnalytics,
  useAnalyticsPageView,
} from '@nerdwallet/seo-analytics';
import { stringInputSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const AutoInsuranceClickTableWrapper = ({
  inventoryType,
  title,
  quinstreetSrcId,
  fetchOffersOnLoad,
  zipCode,
  disableGeolocation,
}) => {
  const { pageViewId, pageViewReady, pageName } = useAnalyticsPageView();
  const segmentInstance = useSegmentAnalytics();

  const analytics = {
    segmentAttributes: {
      driverPageName: pageName,
      pageViewId,
      pageViewReady,
      segmentInstance: segmentInstance.analytics,
    },
  };
  return (
    <AnalyticsContextProvider value={analytics}>
      <StructuredContent>
        {{
          type: 'AutoInsuranceClickTable',
          version: '1.0.0',
          props: {
            inventoryType,
            title,
            quinstreetSrcId,
            fetchOffersOnLoad,
            zipCode,
            disableGeolocation,
          },
        }}
      </StructuredContent>
    </AnalyticsContextProvider>
  );
};

AutoInsuranceClickTableWrapper.propTypes = {
  inventoryType: PropTypes.string,
  title: PropTypes.string,
  quinstreetSrcId: PropTypes.string,
  fetchOffersOnLoad: PropTypes.bool,
  zipCode: PropTypes.string,
  disableGeolocation: PropTypes.bool,
};

AutoInsuranceClickTableWrapper.defaultProps = {
  title: 'Compare auto insurance',
  quinstreetSrcId: '691840',
  fetchOffersOnLoad: true,
  zipCode: '',
  disableGeolocation: false,
};

AutoInsuranceClickTableWrapper.getEditingConfig = (componentDocument) => {
  if (
    componentDocument?.props &&
    !('fetchOffersOnLoad' in componentDocument?.props)
  ) {
    _.set(componentDocument, 'props.fetchOffersOnLoad', true);
  }

  return [
    stringInputSpec('title', 'Title'),
    stringInputSpec('quinstreetSrcId', 'Quinstreet Src Id'),
    stringInputSpec('zipCode', 'Zip Code'),
    stringInputSpec('inventoryType', 'Inventory Type'),
    boolCheckboxSpec('fetchOffersOnLoad', 'Fetch Offers on Load'),
    boolCheckboxSpec('disableGeolocation', 'Disable Geolocation'),
  ];
};

AutoInsuranceClickTableWrapper.displayName = 'AutoInsuranceClickTableWrapper';

export default AutoInsuranceClickTableWrapper;
